import { Typography, Box, Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useField } from "formik";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers";
import { useCallback } from "react";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 14,
    fontWeight: 600,
  },
  optional: {
    fontSize: 12,
    fontWeight: 400,
    color: "gray",
    marginLeft: 6,
  },
  textField: {
    "&> *": {
      borderRadius: 6,
    },
  },
  skeleton: {
    height: 93,
    borderRadius: 4,
    marginTop: -10,
  },
  invisibleInput: {
    appearance: "none",
    border: "none",
    outline: "none",
    margin: 0,
    padding: 0,
    width: "100%",
    height: 1,
    marginBottom: -1,
    opacity: 0.1,
    fontSize: 20,
  },
}));

export default function DatePicker({
  loading = false,
  name = "",
  label = "",
  required = false,
  onChange = undefined,
  disabled = false,
  ...rest
}) {
  const classes = useStyles();
  const [field, meta, helpers] = useField(name);

  const handleChange = useCallback(
    (newDate) => {
      helpers.setValue(newDate);
      if (typeof onChange === "function") {
        onChange(newDate);
      }
    },
    [helpers, onChange]
  );

  return (
    <Box>
      <Typography color={meta.touched && meta.error ? "error" : "text.primary"} gutterBottom className={classes.label}>
        {label}
        {required && "*"}
        {!required && !disabled && (
          <Typography display="inline" className={classes.optional}>
            (optional)
          </Typography>
        )}
      </Typography>
      {loading ? (
        <Skeleton animation={false} className={classes.skeleton} />
      ) : (
        <>
          <MUIDatePicker
            value={field.value}
            onChange={handleChange}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                fullWidth: true,
                classes: { root: classes.textField },
                error: meta.touched && !!meta.error,
                helperText: (meta.touched && meta.error) || " ",
              }
            }}
            disabled={disabled}
            {...rest}
          />
          <input name={name} className={classes.invisibleInput} readOnly />
        </>
      )}
    </Box>
  );
}

DatePicker.propTypes = {
  loading: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
